import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import ReactTable from 'react-table';
import classNames from 'classnames';

import { t } from '../../../../../modules/infra/i18n';
import Title from '../../../Title';
import Checkbox from '../../../../common/Checkbox';
import { poVendorList } from '../shapes';


const VendorList = props => (
  <div className="c-wrapper">
    <Title namespace="po">{t('products:vendors.title')}</Title>
    <Link
      className="c-btn c-btn--medium u-mv-"
      display-if={props.canEditProducts}
      to={`${props.baseUrl}/add`}
    >
      {t('products:vendors.add_vendor_button')}
    </Link>
    <ReactTable
      data={props.listItems}
      showPagination={false}
      defaultPageSize={10000}
      minRows={0}
      className={
        classNames('c-table-new',
          { 'c-no-hover': !props.canEditProducts }
        )
      }
      getTrProps={(_, row) => ({
        onClick: () => props.canEditProducts && props.goToEditing(row.original.id),
      })}
      NoDataComponent={() => (
        <div className="c-table-no-data">
          {t('products:vendors.no_vendors_added_message')}&nbsp;
          <Link className="u-font-color-primary" to={`${props.baseUrl}/add`}>
            {t('products:vendors.add_first_vendor_link')}
          </Link>
        </div>
      )}
      columns={[
        {
          Header: t('products:vendors.table.name_header'),
          accessor: 'name',
        },
        {
          Header: t('products:vendors.table.email_header'),
          accessor: 'email',
        },
        {
          Header: t('products:vendors.table.enabled_header'),
          accessor: 'enabled',
          Cell: row => (
            <Checkbox checked={row.value} readOnly />
          ),
        },
      ]}
    />
  </div>
);

VendorList.propTypes = {
  canEditProducts: PropTypes.bool.isRequired,
  listItems: poVendorList.isRequired,
  goToEditing: PropTypes.func.isRequired,
  baseUrl: PropTypes.string.isRequired,
};

export default VendorList;
